import { searchKey } from '@/config';
import Sess from './sess';

function getSearch() {
  return Sess.get(searchKey);
}

function setSearch(form) {
  return Sess.set(searchKey, form);
}

function removeSearch() {
  return Sess.remove(searchKey);
}

export {
  getSearch,
  setSearch,
  removeSearch
};